import { render } from "./CookiesComponent.vue?vue&type=template&id=62af1d58"
import script from "./CookiesComponent.vue?vue&type=script&lang=js"
export * from "./CookiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__